import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import ProfileForm from './forms/ProfileForm';
import AccountNotifications from './components/AccountNotifications';


function TabContainer({ children, dir, padding }) {
  if (typeof padding === 'undefined') {
    padding = 10;
  }
  return (
    <Typography component="div" dir={dir} style={{ padding: padding, flexGrow: 1, maxHeight: 'calc(100vh - 105px)', overflowY: 'scroll' }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    marginTop: "64px",
  },
  appBar: {
    backgroundColor: 'initial',
    boxShadow: 'none',
    borderBottom: '1px solid #f5f5f5'
  },
  mb: {
    marginBottom: 30
  }
});


class AccountProfile extends React.Component {

  state = {
    activeTab: 0,
    searchQuery: ''
  };

  componentDidMount() {
    let queryString = this.props.location.search;
    if (queryString.search(/\?/ig) !== -1) {
      let result = queryString.match(/at=([0-9]+)/);
      try {
        this.setState({
          activeTab: parseInt(result[1])
        })
      } catch(e) {
        
      }
    }
  }

  handleChange = (event, activeTab) => {
    this.setState({ activeTab });
  };

  render() {
    const { classes, theme } = this.props;

    return (
      <div className={classes.root}>
        <AppBar position="static" color="default" className={classes.appBar}>
          <Tabs
            value={this.state.activeTab}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            fullWidth
          >
            <Tab label="Info" />
            <Tab label="Notificaciones" />
            <Tab label="Historical" />

          </Tabs>
        </AppBar>

        {this.state.activeTab == 0 &&
          <TabContainer padding={25}>
            <ProfileForm />
          </TabContainer>
        }

        {this.state.activeTab == 1 &&
          <TabContainer dir={theme.direction} padding={10}>
            <AccountNotifications />
          </TabContainer>
        }

        {this.state.activeTab == 2 &&
          <TabContainer dir={theme.direction}>
            -
          </TabContainer>
        }

      </div>
    );
  }
}

AccountProfile.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(AccountProfile);


// WEBPACK FOOTER //
// ./src/modules/account/AccountProfile.js